import {RcfaUserInfo} from '@domain/rcfa'
import {ReactComponent as Illustration} from '@hconnect/uikit/src/lib2/pages/illustration403.svg'
import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../localization'

import {RequestAccessButton} from './RequestAccessButton'

interface RequestAccessDialogProps {
  open: boolean
  onClose: () => void
  analysisId?: string
  analysisOwner?: RcfaUserInfo
}

export const RequestAccessDialog = ({
  open,
  onClose,
  analysisId,
  analysisOwner
}: RequestAccessDialogProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Dialog maxWidth={false} open={open} PaperProps={{sx: {width: 400}}} onClose={onClose}>
      <DialogTitle variant="h3" paddingBottom={0}>
        {t('privateAnalysis.title')}
      </DialogTitle>
      <DialogContent sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
        <Box maxWidth="240px" display="flex" justifyContent="center" alignSelf="center">
          <Illustration style={{width: '100%', height: 'auto'}} viewBox="0 0 401 316" />
        </Box>
        <span />
        <DialogContentText whiteSpace={'pre-line'}>
          {t('privateAnalysis.text').replace('.', '.\n\n') + ':'}
        </DialogContentText>
        {!!analysisOwner && (
          <div>
            <DialogContentText fontWeight={500}>{analysisOwner.name}</DialogContentText>
            <DialogContentText variant="caption">{analysisOwner.email}</DialogContentText>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="text" startIcon={<CloseIcon />} sx={{height: 48}} onClick={onClose}>
          {t('buttons.cancel')}
        </Button>
        {analysisId && <RequestAccessButton analysisId={analysisId} successCb={onClose} />}
      </DialogActions>
    </Dialog>
  )
}
